export default {
  en: {
    promotion: 'Promotion',
    newPromotion: 'New Promotion',
    keyword: 'Keyword',
    isDefault: 'Default',
    code: 'Code',
    detail: 'Detail',
    periodOfStay: 'Period of Stay',
    applyRoomType: 'Apply Room Type',
    applyRoomTypeNoData: '-- No Data --',
    applyAllRoomType: 'ALL',
    night: 'Night',
    min: 'Min',
    max: 'Max',
    status: 'Status',
    removePromotionSuccess: 'Remove Promotion Success',
    confirmRemovePromotionTitle: 'Confirm',
    confirmRemovePromotionMessage: 'Confirm to delete Promotion <strong>{promotionCode}</strong>?',
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel',
    updateIsDefaultSuccessTitle: 'Success',
    updateIsDefaultSuccessMessage: 'Update Default Success'
  },
  th: {
    promotion: 'โปรโมชั่น',
    newPromotion: 'สร้างโปรโมชั่น',
    keyword: 'คำที่ต้องการค้นหา',
    isDefault: 'ค่าเริ่มต้น',
    code: 'โค้ด',
    detail: 'รายละเอียด',
    periodOfStay: 'ช่วงเวลาโปรโมชั่น',
    applyRoomType: 'ประเภทห้อง',
    applyRoomTypeNoData: '-- ไม่มีข้อมูล --',
    applyAllRoomType: 'ทั้งหมด',
    night: 'จำนวนวัน',
    min: 'ขั้นต่ำ',
    max: 'สูงสุด',
    status: 'สถานะ',
    removePromotionSuccess: 'ลบโปรโมชั่นสำเร็จ',
    confirmRemovePromotionTitle: 'ยืนยัน',
    confirmRemovePromotionMessage: 'กรุณายืนยันการลบโปรโมชั่น <strong>{promotionCode}</strong>',
    confirmButtonText: 'ยืนยัน',
    cancelButtonText: 'ยกเลิก',
    updateIsDefaultSuccessTitle: 'สำเร็จ',
    updateIsDefaultSuccessMessage: 'แก้ไขค่าเริ่มต้นสำเร็จ'
  }
}
